import { OrbitSuccess } from '#components/atoms/illustrations/OrbitSuccess.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function FeedbackSuccess() {
  return (
    <AuthLayout>
      <CenteredLayout Illustration={OrbitSuccess}>
        <h1 className="h2">Thanks for the feedback</h1>
        <p className="p color-lowlight text-center">We appreciate you taking the time to share your experience.</p>
      </CenteredLayout>
    </AuthLayout>
  );
}
